import styled from "styled-components";
import CheckerboardTile from "../../../assets/checkerboard-tile.png";
const Checkerboard = styled.div `
    position: relative;
    background: url(${CheckerboardTile});
    background-repeat: repeat;
    border: 1px solid #999999;
    border-radius: 4px;
    overflow: hidden;
`;
export default Checkerboard;
